import { FC } from 'react';

import { Stack, Typography } from '@mui/material';

interface IDiagnosticCardResultDescription {
  resultValue: number;
  maxResult: number;
  description?: string;
  descriptionColor: string;
}

const DiagnosticCardResultDescription: FC<IDiagnosticCardResultDescription> = ({
  resultValue,
  maxResult,
  description,
  descriptionColor,
}) => {
  return (
    <Stack>
      <Typography variant="Paragraph MD/Regular">
        <Typography variant="Paragraph MD/Bold" component="span">
          {resultValue} баллов
        </Typography>{' '}
        из {maxResult}
      </Typography>
      {description && (
        <Typography variant="Paragraph MD/Semi Bold" color={descriptionColor}>
          {description.toLowerCase()}
        </Typography>
      )}
    </Stack>
  );
};

export default DiagnosticCardResultDescription;
